import {
  useState, useEffect, useCallback,
} from 'react';

import ReportsServices from '../state/reports.service';

/**
 * Custom exports the current user may view/run (GET /exports).
 * Redux `customExports` holds the full catalog from GET /exports/all (settings).
 */
export default function useViewableCustomExports() {
  const [viewableExports, setViewableExports] = useState([]);

  const refetch = useCallback(() => {
    ReportsServices.getCustomExports().then((result) => {
      const { data } = result ?? {};
      setViewableExports(Array.isArray(data) ? data : []);
    });
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return [viewableExports, refetch];
}
